import { AutoRedactionRule } from './auto-redaction-rule.model';
import { RunStatus } from './run-status.enum';

export class AutoRedactionJob {
	id: string;
	caseId: string;
	title: string;
	createdById: string;
	dateTimeCreated: string;
	dateTimeRun: string;
	runStatus: RunStatus;
	isDeleted: boolean;
	filterId?: string;
	processingDocCount?: number;
	redactedDocCount?: number;
	lastModified: string;
	autoRedactionRules: AutoRedactionRule[];
}
